function getAutoInput(h, context) {
  // 初始化
  const { data, props } = context;
  const { attrs } = data;
  const { options, queryItem, dictionaryType } = props.query;

  // 设置标签
  let tag = `el-${props.query.component || 'input'}`;

  // 更新值
  function setInput(nv) {
    const val = typeof nv === 'string' ? nv.trim() : nv;
    context.listeners['update:value'](val);
  }
  // enter事件
  function onEnter(e) {
    if (props.query.keyup) {
      context.listeners.keyup(e);
    }
  }

  // 自定义组件调用
  if (props.query.component === 'search-input-select') {
    tag = 'search-input-select';
  } else if (props.query.component === 'search-date-picker') {
    tag = 'search-date-picker';
  } else if (props.query.component === 'select') {
    tag = 'jr-select';
  }

  const tagContent = () => (
    <tag
      {...{ attrs }}
      {...{ on: context.listeners }}
      {...{ model: {
        value: props.value,
        callback: setInput,
      } }}
      queryItem={queryItem}
      query={props.query}
      nativeOnKeyup={onEnter}
      options={options}
      dictionaryType={dictionaryType || ''}
    >
    </tag>
  );

  return tagContent;
}

export default getAutoInput;

